import { useEffect } from 'react'

import { useSetFocus } from '@please/lrud'
import { useLocation } from 'react-router-dom'

import { focusIds } from '@/constants/focus'
import { paths } from '@/constants/paths'
import { popupStatus } from '@/constants/popup'
import useStore from '@/store/useStore'
import { MediaContentType } from '@/types/servicesTypes/configTypes'

type Props = { mediaContent: Nullable<MediaContentType> }

export const useToggleFullscreenFocus = ({ mediaContent }: Props) => {
  const { pathname } = useLocation()
  const setFocus = useSetFocus()

  const currentEvent = useStore((state) => state.common.currentEvent)
  const setListPopup = useStore((state) => state.common.setListPopup)
  const { pagePopupStatus } = useStore((state) => state.popup)

  const isPagePopupOpen = pagePopupStatus !== popupStatus.CLOSED

  const isPagePath =
    pathname.startsWith(paths.PAGE) || pathname.startsWith(paths.FAVORITES)

  useEffect(() => {
    if (mediaContent) {
      setFocus(focusIds.FULLSCREEN_PLAYER)
      return () => {
        const listPopup = mediaContent?.listOptions
        if (listPopup) {
          setListPopup(listPopup)
        }
        if (currentEvent) {
          return setFocus(
            `${focusIds.EVENT_PAGE}_${focusIds.POPUP}${focusIds.CONTAINER_MOD}`,
          )
        }
        if (isPagePopupOpen) {
          return setFocus(
            `${focusIds.PAGE}_${focusIds.POPUP}${focusIds.CONTAINER_MOD}`,
          )
        }
        if (isPagePath) {
          return setFocus(`${focusIds.PAGE}${focusIds.CONTAINER_MOD}`)
        }
        setFocus(focusIds.CONTENT)
      }
    }
  }, [mediaContent])
}
